import Vue from 'vue';
import WpPageBaseComponent from '../wp-page-base-component';
import Component, { mixins } from 'vue-class-component';

import GlobalService, {
    IContext, IdentitySymbols, IdentityChangedEventArgs,
    INotificationService, NotificationSymbols, Initializer,
    ILoyaltyProvider, LoyaltySymbols, AppSettingsInitializedEventArgs,
    NotificationEventArgs, NotificationTypes, AppSettings, IsdUserLoyalty, createGuid
} from 'web-platform-core-ui';

export const WpClientsCardsProp = Vue.extend({

})

@Component({
    template: require("./wp-clients-cards.html")
})
export default class WpClientsCards extends mixins(WpPageBaseComponent, WpClientsCardsProp, Vue) {
    protected _notificationService!: INotificationService;
    protected _loyaltyProvider!: ILoyaltyProvider;

    UserLoyalty!: IsdUserLoyalty;
    Cards: Array<any> = [];
    FullName: string = '';

    WaitNewCard: boolean = false;
    NewCardDialog: boolean = false;

    protected _refreshCardsFunc: any;

    async mounted(): Promise<void> {
        let context = this.GlobalService.Get<IContext>(IdentitySymbols.Context);
        this._notificationService = this.GlobalService.Get<INotificationService>(NotificationSymbols.NotificationService);
        this._loyaltyProvider = this.GlobalService.Get<ILoyaltyProvider>(LoyaltySymbols.LoyaltyProvider);


        let result = await this._loyaltyProvider.GetIsdUserLoyaltyAsync();

        if (result.Success && result.Data != null) {
            this.UserLoyalty = result.Data;
            this.FullName = `${this.UserLoyalty.LastName} ${this.UserLoyalty.FirstName} ${this.UserLoyalty.SecondName}`

            let cards = await this._loyaltyProvider.GetCards(this.UserLoyalty.PersId);
            this.Cards = cards.filter(x => x.bearer_type == "41");

            let length = localStorage.getItem("new_card");
            localStorage.removeItem("new_card");

            if (length != null) {
                this.NewCardDialog = true;

                if (length == this.Cards.length.toString()) {
                    this.WaitNewCard = true;

                    this._refreshCardsFunc = setInterval(async () => {
                        let cards = (await this._loyaltyProvider.GetCards(this.UserLoyalty.PersId)).filter(x => x.bearer_type == "41");
                        if (cards.length.toString() != length) {
                            this.WaitNewCard = false;
                            this.Cards = cards;
                            clearInterval(this._refreshCardsFunc);
                            this._refreshCardsFunc = null;
                        }
                    }, 5000);
                } else {
                    this.WaitNewCard = false;  
                }

            }

        } else {
            this._notificationService.Error('', result?.ErrorMessage ?? 'Произошла непредвиденная ошибка');
        };
    }

    AddNewCard() {
        localStorage.setItem("new_card", `${this.Cards.length}`);

        var complete = `${location.origin}/card/complete`;
        var failed = `${location.origin}/card/failed`;

        var guid = createGuid();


        let url = '';
        if (GlobalService.GetSettings().IsDevVersion) {
            url = 'https://payments.t.paysecure.ru/pay/regcard.cfm?merchant_id=697927';
        } else {
            url = 'https://payments367.paysecure.ru/pay/regcard.cfm?merchant_id=640930';
        }

        location.href = `${url}&customernumber=${this.UserLoyalty.PersId}&ordernumber=${guid}&URL_RETURN_OK=${complete}&URL_RETURN_NO=${failed}`;
    }

    GetDate(date: string) {
        return this.DateHandler.Parse(date.split("T")[0], "YYYY-MM-DD").Format("DD.MM.YYYY"); 
    }

    OpenWidget(mediaNum: string) {
        this._notificationService.SendSystemNotification("OpenWidget", mediaNum);
    }

    NewCardDialogClose() {
        this.NewCardDialog = false;
    }
};